$(document).ready(function() {
    $('#descr-1').removeClass('inactive-desc');
    $('#descr-1').addClass('active-desc');
    $.getJSON('/cart.js', function(cart) {
        console.log(cart);
        $('p#cart-item-count').text(cart.item_count);
    });

    $('.flavor-carousel-container').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: true,
        arrows: true,
        appendArrows: $('.flavor-carousel-container'),
        prevArrow:'<span id="prev"></span>',
        nextArrow:'<span id="next"></span>',
        infinite: true,
        responsive: [
            {
            breakpoint: 768,
            settings: {
                arrows: true,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 3,
                infinite: true,
            }
            }
        ]
    });
      
    $('.flavor-carousel-container').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.flavor-description').each(function() {
            $(this).addClass('inactive-desc');
            $(this).removeClass('active-desc');
        });
        
        var nextactive = $('[data-slick-index='+nextSlide+']').attr('id');
        nextactive = nextactive.replace('flavor-','descr-');
        $('#'+nextactive).addClass('active-desc');
        $('#'+nextactive).removeClass('inactive-desc');

        // --- NEW CODE: UPDATE AMAZON BUTTON LINK ---
        var newAmazonLink = $('[data-slick-index=' + nextSlide + ']').attr('data-amazon-link');
        
        if (newAmazonLink && newAmazonLink !== "") {
          $('.amazon_link_product a').attr('href', newAmazonLink).show();
        } else {
          $('.amazon_link_product a').hide();
        }
        // -------------------------------------------
    });

    $('#lsg-nutr-info-var').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
    });
  
    $('#lsg-nutr-info-sampler').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
    });
      
    $('div#lsg-product-info-var').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
    });
  
    $('div#lsg-product-info-sampler').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
    });

    $('#lsg-nutr-info-var').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('div#lsg-product-info-var').each(function() {
            $(this).slick('slickGoTo', nextSlide, true);
        });
    });

    $('div#lsg-product-info-var').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('#lsg-nutr-info-var').each(function() {
            $(this).slick('slickGoTo', nextSlide, true);
        });
    });
  
    $('#lsg-nutr-info-sampler').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('div#lsg-product-info-sampler').each(function() {
            $(this).slick('slickGoTo', nextSlide, true);
        });
    });

    $('div#lsg-product-info-sampler').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('#lsg-nutr-info-sampler').each(function() {
            $(this).slick('slickGoTo', nextSlide, true);
        });
    });
});